<div class="treasure-item" [ngClass]="{ 'win': background === bg.Win, 'lose': background === bg.Lose, 'key': background === bg.Key }">
    <div class="rocks"></div>
    <div class="chest-shadow" [class.opened]="opened"></div>

    <!-- Extra elements -->
    <!-- Win case -->
    <ng-container *ngIf="background === bg.Win">
        <div class="win-glow"></div>
        <div class="win-coins">
            <div class="coin-1"></div>
            <div class="coin-2"></div>
            <div class="coin-3"></div>
        </div>
    </ng-container>

    <!-- Lose case -->
    <ng-container *ngIf="background === bg.Lose">
        <div class="bomb"></div>
    </ng-container>

    <!-- Key case -->
    <ng-container *ngIf="background === bg.Key">
        <div class="key"></div>
    </ng-container>

    <div class="chest-wrap">
        <div *ngIf="!openedParts" class="chest" [ngClass]="{ 'golden-chest': row === isLastRow, 'opened': opened }"></div>
        <div class="chest-top" [ngClass]="{ 'golden': row === isLastRow, 'opened': openedParts }"></div>
        <div class="chest-body" [ngClass]="{ 'golden': row === isLastRow, 'opened': openedParts }"></div>
    </div>
    <div class="glow"></div>
    <div class="item-label">
        <ng-container *ngIf="background === bg.Lose">
            <div class="icon-bust"></div>
            <div class="text-bust">Bust!</div>
        </ng-container>
        <ng-container *ngIf="background !== bg.Lose && background !== bg.Key && opened && openedParts">
            <div class="icon-coins"></div>
            <div class="text-amount">Win !</div>
        </ng-container>
        <ng-container *ngIf="background === bg.Key">
            <div class="icon-key"></div>
            <div class="text-key">Key</div>
        </ng-container>
    </div>
</div>


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/reply/reply-treasure/treasure-reply-item.component.html